import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AddProtectionService {
  public add = new EventEmitter<string>();
  public mortgageId: string;
  public mortgageAdvisorId: string;
}
